import React from "react";
import PropTypes from "prop-types";
import { Menu, Dropdown } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { useAbility } from "@casl/react";
import { AbilityContext } from "@app/context/casl/abilityContext";
import { LanguageSelector } from "../LanguageSelector/languageSelector.component";
import "./user-settings.css";
import { I18n } from "aws-amplify";

export const UserSettings = ({
  headerText,
  options,
  onClick,
  languageText,
  languages,
  locale,
  handleLocaleChange,
  className,
}) => {
  const ability = useAbility(AbilityContext);
  const menu = (
    <Menu>
      <Menu.Item
        key="user-settings-header-title-item"
        className="user-settings-menu-item"
      >
        <div className="user-settings-menu-item-header">{headerText}</div>
      </Menu.Item>
      {options.map(
        (option, index) =>
          ability.can("read", `dm.${option.name}`) && (
            <Menu.Item
              className="user-settings-menu-item"
              key={`admin-item-${index}`}
              icon={option.icon}
              onClick={() => onClick(option.path)}
            >
              <div
                className="user-settings-menu-item-title"
                style={{ marginLeft: "14px" }}
              >
                {I18n.get(option.title)}
              </div>
              <div
                className="user-settings-menu-item-description"
                style={{ marginLeft: "14px" }}
              >
                {I18n.get(option.description)}
              </div>
            </Menu.Item>
          )
      )}
      <Menu.Item
        key="language-selector-item"
        style={{ borderTop: "1px solid #ebebeb" }}
        className="user-settings-menu-item"
      >
        <div className="user-settings-menu-item-language">
          <div className="user-settings-menu-item-title">{languageText}</div>
          <LanguageSelector
            defaultValue={locale}
            languages={languages}
            onChange={handleLocaleChange}
          />
        </div>
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown
      overlay={menu}
      placement="bottomRight"
      trigger={["click", "hover"]}
      overlayClassName={`user-settings-dropdown-menu user-settings-dropdown-menu-title-content ${className}`}
      overlayStyle={{ minWidth: "300px" }}
    >
      <SettingOutlined style={{ fontSize: "30px", color: "#4ab1eb" }} />
    </Dropdown>
  );
};

UserSettings.propTypes = {
  headerText: PropTypes.string.isRequired,
  options: PropTypes.shape({
    path: PropTypes.string,
    icon: PropTypes.node,
    label: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  languageText: PropTypes.string.isRequired,
  languages: PropTypes.array.isRequired,
  locale: PropTypes.string.isRequired,
  handleLocaleChange: PropTypes.node.isRequired,
  className: PropTypes.string,
};

UserSettings.defaultProps = {
  className: undefined,
};
